export const getColumnKey = (columnNamespace, columnName) => `${columnNamespace}-${columnName}`;